import { Injectable } from '@angular/core';

export {
    getLocalPrintRelayPlatformInfo,
    getLocalPrintRelayToolDescriptor,
    isLocalPrintRelayDownloadSupported,
} from './local-print-relay-platform.util';

export type {
    LocalPrintRelayClientKind,
    LocalPrintRelayPlatformInfo,
    LocalPrintRelayToolDescriptor,
    LocalPrintRelayToolPlatform,
} from './local-print-relay-platform.util';

export const LOCAL_PRINT_RELAY_URL = 'ws://127.0.0.1:8080';
export const LOCAL_PRINT_RELAY_SUPPORT_TOOLTIP =
    'Print-Relay lokal starten. Bei "Offline": Tool erneut starten und Status mit --status prüfen.';
export const LOCAL_PRINT_RELAY_SUPPORT_INFO_LINES = [
    'Print-Relay lokal starten (Windows: Up2Boat-PrintRelay.exe, macOS: print-relay-macos).',
    'Danach läuft es automatisch als Hintergrunddienst.',
    'Bei "Print-Relay Offline": Installation erneut starten und --status prüfen.',
];

@Injectable({ providedIn: 'root' })
export class LocalPrintRelayWatchdogService {
    ping(timeoutMs = 2500): Promise<boolean> {
        return new Promise<boolean>((resolve) => {
            const socket = new WebSocket(LOCAL_PRINT_RELAY_URL);
            let finished = false;

            const timeoutHandle = setTimeout(() => {
                resolveOnce(false);
            }, timeoutMs);

            const closeSocket = () => {
                try {
                    socket.close();
                } catch (_error) {
                    // no-op
                }
            };

            const resolveOnce = (isActive: boolean) => {
                if (finished) {
                    return;
                }
                finished = true;
                clearTimeout(timeoutHandle);
                closeSocket();
                resolve(isActive);
            };

            socket.onopen = () => {
                socket.send(JSON.stringify({ action: 'ping' }));
            };

            socket.onmessage = (event: MessageEvent) => {
                try {
                    const response = JSON.parse(String(event.data ?? '{}'));
                    resolveOnce(response?.status === 'pong');
                    return;
                } catch (_error) {
                    resolveOnce(false);
                    return;
                }
            };

            socket.onerror = () => {
                resolveOnce(false);
            };

            socket.onclose = () => {
                if (!finished) {
                    resolveOnce(false);
                }
            };
        });
    }
}
